export const API_KEY_TOKEN_PLACEHOLDER = '<your token>'

/**
 * The address an outside system pushes files to for one intake. The single
 * place this path is spelled: the curl builder and the Intakes tab both use
 * it, so the displayed URL and the copied command cannot drift apart.
 */
export function intakePushFilesUrl(proxyApiV1Url: string, intakeName: string): string {
  const base = proxyApiV1Url.replace(/\/+$/, '')
  return `${base}/ontology/ingest/intakes/${encodeURIComponent(intakeName)}/files`
}

export interface IntakeUploadCurlInput {
  proxyApiV1Url: string
  intakeName: string
  token: string
  fileName?: string
}

export function buildIntakeUploadCurl({
  proxyApiV1Url,
  intakeName,
  token,
  fileName = 'example.xlsx'
}: IntakeUploadCurlInput): string {
  const url = intakePushFilesUrl(proxyApiV1Url, intakeName)
  return [
    'curl --fail-with-body --request POST \\',
    `  "${url}" \\`,
    `  --header "Authorization: Bearer ${token}" \\`,
    `  --form "file=@${fileName}"`
  ].join('\n')
}
